import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {
    SearchValuationsAtAddressRequest,
    SearchValuationsAtAddressResult,
} from "../payload-types/search-valuations-at-address";

/**
 * #18907: API interface for the duplicate-address lookup (POST {@link RevaApi.PATH_VALUATIONS_SEARCH_AT_ADDRESS}).
 * Sends coordinate + the combined street (incl. house number, unsplit) as a JSON body and returns the existing
 * valuations at that address in the caller's license. The backend splits the street canonically.
 */
export class SearchValuationsAtAddressApiInterface extends SimpleApiInterface<SearchValuationsAtAddressResult> {
    constructor(private readonly request: SearchValuationsAtAddressRequest) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS_SEARCH_AT_ADDRESS]);
    }

    protected buildPayload(): Record<string, unknown> {
        const r = this.request;
        return {
            coordinate: r.coordinate,
            street: r.street,
        };
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<SearchValuationsAtAddressResult> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }
}
